import React from 'react';

import AvGroup from './AvGroup';
import QtyInput from './QtyInput';

export default props => (
  <AvGroup>
    <QtyInput {...props} />
  </AvGroup>
);
